package link.erpango.quip.catalog

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.Icon
import androidx.compose.material.IconButton
import androidx.compose.material.MaterialTheme
import androidx.compose.material.ScrollableTabRow
import androidx.compose.material.Tab
import androidx.compose.material.Text
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowBack
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import link.erpango.quip.catalog.sections.CatalogColorsSection
import link.erpango.quip.catalog.sections.CatalogComponentsSection
import link.erpango.quip.catalog.sections.CatalogDimensSection
import link.erpango.quip.catalog.sections.CatalogIconsSection
import link.erpango.quip.catalog.sections.CatalogTypographySection
import link.erpango.quip.theme.QuipColors
import link.erpango.quip.ui.components.QuipTransparentHeader

enum class CatalogTab(val label: String) {
    COLORS("Colores"),
    TYPOGRAPHY("Tipografía"),
    DIMENSIONS("Espaciado"),
    COMPONENTS("Componentes"),
    ICONS("Iconos"),
}

@Composable
fun CatalogScreen(onBack: () -> Unit) {
    var selectedTab by remember { mutableStateOf(CatalogTab.COLORS) }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(QuipColors.colorBackground)
    ) {
        QuipTransparentHeader {
            Row(verticalAlignment = Alignment.CenterVertically) {
                IconButton(onClick = onBack) {
                    Icon(
                        imageVector = Icons.Default.ArrowBack,
                        contentDescription = "Volver",
                        tint = QuipColors.colorText,
                    )
                }
                Text(
                    text = "Design System",
                    style = MaterialTheme.typography.h4,
                    fontWeight = FontWeight.Bold,
                    color = QuipColors.colorText,
                )
            }
        }

        ScrollableTabRow(
            selectedTabIndex = selectedTab.ordinal,
            backgroundColor = QuipColors.colorSurface,
            contentColor = QuipColors.colorPrimary,
        ) {
            CatalogTab.entries.forEach { tab ->
                Tab(
                    selected = selectedTab == tab,
                    onClick = { selectedTab = tab },
                    text = {
                        Text(
                            text = tab.label,
                            color = if (selectedTab == tab) QuipColors.colorPrimary
                                    else QuipColors.colorTextSecondary,
                        )
                    },
                )
            }
        }

        Box(modifier = Modifier.weight(1f)) {
            when (selectedTab) {
                CatalogTab.COLORS     -> CatalogColorsSection()
                CatalogTab.TYPOGRAPHY -> CatalogTypographySection()
                CatalogTab.DIMENSIONS -> CatalogDimensSection()
                CatalogTab.COMPONENTS -> CatalogComponentsSection()
                CatalogTab.ICONS      -> CatalogIconsSection()
            }
        }
    }
}
